import { render, staticRenderFns } from "./ChartSamplesCount.vue?vue&type=template&id=87964176"
import script from "./ChartSamplesCount.vue?vue&type=script&lang=js"
export * from "./ChartSamplesCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports